import React from 'react';

const BillingAddressRenderer = (props) => {
  const determineSendingMessage = () => {
    if (!props.existingClient) {
      return 'החשבונית תישלח לכתובת מייל:';
    } else {
      if (props.billingType) {
        switch (props.billingType) {
          case 'Email':
            return 'החשבונית תישלח לכתובת מייל:';
          case 'SMS':
            return 'החשבונית תישלח בהודעה למספר:';
          case 'Address':
            return 'החשבונית תישלח לכתובת:';
        }
      }
    }
    return '';
  };

  const determineBillingData = () => {
    if (!props.existingClient) {
      return props.formEmail;
    } else {
      return props.billingData;
    }
  };

  const whereToSendData = determineSendingMessage();
  if (whereToSendData != '') {
    return (
      <div className='bottom-where-flight-to-shadowtext' style={{marginBottom: '8px'}}>
        <div>{whereToSendData}</div>
        <div style={{display: 'flex'}}>
          <span className='bold mx-1'>{determineBillingData()}</span>
          <div className='bottom-pink-text-click' onClick={props.onclick}>
            עדכון
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className='bottom-where-flight-to-shadowtext' style={{marginBottom: '8px'}}>
      <div>החשבונית תישלח לכתובת מייל:</div>
      <div style={{display: 'flex'}}>
        <span className='bold mx-1'></span>
        <div className='bottom-pink-text-click' onClick={props.onclick}>
          עדכון
        </div>
      </div>
    </div>
  );
};

export default BillingAddressRenderer;
